import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Reveal, MaskText } from "@/components/Reveal";
import { STORY_IMAGE } from "@/data/site";

export function BrandStory() {
  return (
    <section className="mx-auto grid max-w-[1400px] items-center gap-12 px-5 py-24 md:grid-cols-2 md:gap-20 md:px-10 md:py-36" data-testid="brand-story">
      <Reveal className="order-2 md:order-1">
        <div className="relative overflow-hidden rounded-2xl">
          <motion.img
            src={STORY_IMAGE}
            alt="Noora Jewels story"
            initial={{ scale: 1.15 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
            className="aspect-[4/5] w-full object-cover"
          />
        </div>
      </Reveal>

      <div className="order-1 md:order-2">
        <p className="eyebrow text-gold">Our Story</p>
        <MaskText
          animateOnLoad={false}
          lines={["Made to Shine.", "Made to Last."]}
          className="mt-5 font-serif text-4xl font-light leading-[1.02] tracking-tight text-ink md:text-6xl"
        />
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-lg text-base leading-relaxed text-ink/70">
            At Noora Jewels, we believe jewelry should be more than an accessory. It should be a
            reflection of your style, confidence, and individuality. Our pieces are designed for
            everyday moments—beautiful, effortless, and made to stay part of your story.
          </p>
          <Link
            to="/about"
            className="mt-10 inline-block rounded-full border border-ink px-9 py-4 text-[0.72rem] uppercase tracking-[0.24em] text-ink transition-colors duration-300 hover:bg-ink hover:text-ivory"
            data-testid="discover-story"
          >
            Discover Our Story
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
